import { render } from "./PhoneChild.vue?vue&type=template&id=7e315b53"
import script from "./PhoneChild.vue?vue&type=script&lang=js"
export * from "./PhoneChild.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__